import { render, staticRenderFns } from "./CustomTables.vue?vue&type=template&id=2daf59cf&"
import script from "./CustomTables.vue?vue&type=script&lang=js&"
export * from "./CustomTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports